import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { LoaderService } from 'src/app/core/_config/loader.service';
import { JournalService } from 'src/app/services/journal.service';
import { JournalStatusEnum } from '../enum/journal-status';
import { forkJoin } from 'rxjs';
import { switchMap, finalize } from 'rxjs/operators';
import { AccountingAttachmentComponent } from './accounting-attachments/accounting-attachment/accounting-attachment.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    templateUrl: './batch-details.component.html',
    styleUrls: ['./batch-details.component.scss'],
})
export class BatchDetailsComponent implements OnInit {
    journal: any;
    journalItens: any[] = [];
    journalItensOriginal: any[];
    panelOpenState = false;
    loadingItens = true;
    loadingBatch = true;
    loadingRows = true;

    resJournal = false;
    resItens = false;
    //filters
    accountFilter: string;
    subAccountFilter: string;

    private _sortedItems: any[] = [];

    constructor(
        private route: ActivatedRoute,
        private journalService: JournalService,
        public loaderService: LoaderService,
        private cdref: ChangeDetectorRef,
        private notification: NotificationsService,
        private _dialog: MatDialog,
        private spinner: NgxSpinnerService,
    ) {
        this.accountFilter = '';
        this.subAccountFilter = '';
        this.journalItensOriginal = [];
    }

    ngOnInit(): void {
        this.route.paramMap
            .pipe(
                switchMap((params) => {
                    const id = params.get('id');
                    this.loadingBatch = true;
                    this.loadingItens = true;
                    this.loadingRows = true;
                    this.loaderService.show();
                    return this.journalService.GetByIdWithItems(id);
                }),
            )
            .subscribe((response) => {
                this.journal = response;
                this.journalItens = response.items;
                this.journalItensOriginal = response.items;
                this.sortItems();
                this.loadingBatch = false;
                this.loadingItens = false;
                this.loadingRows = false;
                this.loaderService.hide();
            });
    }

    refresh() {
        this.getJournalItens(this.journal.journalId);
    }

    getJournal(id) {
        this.loadingBatch = true;
        this.loaderService.show();
        this.cdref.detectChanges();

        this.journalService.getById(id).subscribe((res) => {
            this.journal = res;
            this.loadingBatch = false;
            this.loaderService.hide();
            this.cdref.detectChanges();

            this.getJournalItens(id);
        });
    }

    getJournalItens(journalId) {
        this.loadingItens = true;
        this.loaderService.show();
        this.cdref.detectChanges();

        this.journalService.getJournalItens(journalId).subscribe((res) => {
            this.journalItens = res;
            this.journalItensOriginal = res;
            this.sortItems();
            this.loadingItens = false;
            this.loaderService.hide();
            this.cdref.detectChanges();
        });
    }

    updateAllJournalItem() {
        this.loaderService.show();
        this.notification.success('Aguarde...');

        this.journalService.CancelDracma(this.journal.journalId).subscribe((item) => {
            const updates = this.journalItens.map((item) =>
                this.journalService.updateJournalItem(this.journal.journalId, item),
            );
            forkJoin(updates)
                .pipe(finalize(() => this.loaderService.hide()))
                .subscribe(() => {
                    this.getJournalItens(this.journal.journalId);
                    this.notification.success('Salvo com sucesso');
                });
        });
    }

    reSendBatch() {
        this.loaderService.show();
        this.journalService.getStatusByJournalId(this.journal.journalId).subscribe((status) => {
            if (
                status == JournalStatusEnum.Default ||
                status == JournalStatusEnum.CreationError ||
                status == JournalStatusEnum.ExportError
            ) {
                this.journalService.exportJournal(this.journal.journalId).subscribe(
                    (res) => {
                        this.loaderService.hide();
                        this.getJournalItens(this.journal.journalId);
                        this.notification.success('Lote Exportado com Sucesso');
                    },
                    (dataError) => {
                        this.loaderService.hide();
                        this.getJournalItens(this.journal.journalId);
                        this.notification.error(`Erro ao enviar Lote = ${dataError.error} `);
                    },
                );
            } else {
                if (status == JournalStatusEnum.Awaiting) {
                    // Waiting
                    this.notification.alert('Lote está sendo enviado para o AASI em segundo plano, por favor aguarde.');
                } else {
                    // Exported
                    this.getJournalItens(this.journal.journalId);
                    this.notification.error('Lote Exportado com Sucesso.');
                }
            }
        });
    }

    private sortItems() {
        if (!this.journalItens) {
            this._sortedItems = [];
            return;
        }
        this._sortedItems = [...this.journalItens].sort((a, b) => {
            return (a.sortOrder || 0) - (b.sortOrder || 0);
        });
    }

    public get sortableItens() {
        return this._sortedItems;
    }

    parseError(item) {
        if (item.detail) {
            return `${item.message} : ${item.detail}`;
        } else {
            return `${item.message}`;
        }
    }

    disableEditing(): boolean {
        const statusId = this.journal?.journalStatusId;
        return statusId !== 3 && statusId !== 4;
    }

    filterAccountSucAccount() {
        if (!this.accountFilter && !this.subAccountFilter) {
            this.journalItens = this.journalItensOriginal;
        } else {
            this.journalItens = this.journalItensOriginal.filter((item) => {
                const matchAccount =
                    !this.accountFilter || (item.accountCode && item.accountCode.includes(this.accountFilter));
                const matchSubAccount =
                    !this.subAccountFilter || (item.subAccount && item.subAccount.includes(this.subAccountFilter));
                return matchAccount && matchSubAccount;
            });
        }
        this.sortItems();
    }

    attachments() {
        this.spinner.show();
        this.journalService.GetAttachments(this.journal.journalId).subscribe((result) => {
            this.spinner.hide();
            if (!result.isSuccess) {
                this.notification.warn(result.message);
                return;
            }

            let dataExistent = result.data;
            const dialogConfig = new MatDialogConfig();
            dialogConfig.autoFocus = true;
            dialogConfig.width = '1200px';
            dialogConfig.data = {
                journalId: this.journal.journalId,
                dataExistent: dataExistent,
            };
            const dialogRef = this._dialog.open(AccountingAttachmentComponent, dialogConfig);
            dialogRef.afterClosed().subscribe(() => {
                //popup closed
            });
        });
    }
}
